// extracted by mini-css-extract-plugin
export default {"wrapper_qr_video":"qr_style_wrapper_qr_video__yqwEU","wrapper_qr_video_error":"qr_style_wrapper_qr_video_error__LB-xY","window":"qr_style_window__nz+ce"};